import React from "react";
/* eslint-disable max-len */

interface BuildingProps {
  size?: number;
  color?: string;
}

const Building: React.FC<BuildingProps> = ({ size = 32, color = "#5A5A5A" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1.99805 27.8389H29.998"
    />
    <path
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.9973 27.8389V5.83887C17.9973 5.57365 17.892 5.3193 17.7044 5.13176C17.5169 4.94422 17.2625 4.83887 16.9973 4.83887H4.99731C4.7321 4.83887 4.47774 4.94422 4.29021 5.13176C4.10267 5.3193 3.99731 5.57365 3.99731 5.83887V27.8389"
    />
    <path
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M27.9973 27.8389V13.8389C27.9973 13.5737 27.892 13.3193 27.7044 13.1318C27.5169 12.9442 27.2625 12.8389 26.9973 12.8389H17.9973"
    />
    <path
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.99731 9.83887H11.9973"
    />
    <path
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.99731 17.8389H13.9973"
    />
    <path
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.99731 22.8389H11.9973"
    />
    <path
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.9973 22.8389H23.9973"
    />
    <path
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.9973 17.8389H23.9973"
    />
  </svg>
);

export default Building;
